/* eslint-disable react/require-default-props */
import { mergeOverrides } from 'baseui';
import {
  Banner as BaseBanner,
  BannerProps as BaseBannerProps,
  KIND,
  StyledRoot,
} from 'baseui/banner';
import React, { useEffect, useRef } from 'react';

import SchedulerTheme, { withStyle } from 'theme';

type OwnProps = { show?: boolean; inset?: boolean };
type BannerProps = BaseBannerProps & OwnProps;

type StyledRootProps = {
  $nested: boolean;
  $kind: keyof typeof KIND;
};
const Root = withStyle<typeof StyledRoot, StyledRootProps>(
  StyledRoot,
  ({ $kind }) => ({
    ...getKindStyles($kind),
  }),
);
export default function Banner(props: BannerProps) {
  const rootRef = useRef<HTMLDivElement>(null);
  const {
    overrides,
    show = true,
    inset = false,
    ...propsWithoutOverrides
  } = props;
  const { kind } = props;
  useEffect(() => {
    if (show && rootRef.current) {
      rootRef.current.focus();
    }
  }, [show]);

  if (show) {
    return (
      <BaseBanner
        {...propsWithoutOverrides}
        overrides={mergeOverrides(
          {
            Root: {
              component: Root,
              props: { $kind: kind, ref: rootRef, tabIndex: 0 },
              style: {
                ...(!inset
                  ? {
                      marginTop: 0,
                      marginLeft: 0,
                      marginBottom: 0,
                      marginRight: 0,
                    }
                  : {}),
              },
            },
          },
          overrides,
        )}
      />
    );
  }
  return null;
}

function getKindStyles(kind?: keyof typeof KIND) {
  if (!kind) return Object.freeze({});
  switch (kind) {
    case KIND.negative: {
      return {
        color: SchedulerTheme.colors.negative,
        backgroundColor: SchedulerTheme.colors.negative50,
      };
    }
    case KIND.info: {
      return {
        color: SchedulerTheme.colors.white,
        backgroundColor: SchedulerTheme.colors.primary,
      };
    }
    case KIND.positive: {
      return {
        color: SchedulerTheme.colors.positive,
        backgroundColor: SchedulerTheme.colors.positive50,
      };
    }
    case KIND.warning: {
      return {
        color: SchedulerTheme.colors.warning,
        backgroundColor: SchedulerTheme.colors.warning50,
      };
    }
    default:
      return Object.freeze({});
  }
}
